import { useSessionData } from './useSessionData'

function createInstance() {
  const { sessionData } = useSessionData()
  const widgetSettings = sessionData.widget

  // mock
  // widgetSettings.active = true
  // widgetSettings.options = {}
  // widgetSettings.options.type = 'main'
  // widgetSettings.options.specific_pages = [
  //   'schedule.month',
  //   'schedule.week',
  //   'schedule.day',
  //   'memberships',
  //   'documents',
  //   'store',
  //   'content',
  //   'appointments',
  //   'forms_and_waivers',
  //   'courses',
  //   'my_account.upcoming_registrations',
  //   'my_account.profile',
  //   'my_account.memberships',
  //   'my_account.reservations',
  //   'my_account.registrations',
  //   'my_account.payments',
  //   'my_account.documents',
  //   'my_account.referrals',
  //   'my_account.notifications',
  //   'my_account.contact',
  // ]
  // widgetSettings.options.view = 'schedule.month'

  // mock
  // Object.assign(widgetSettings, {
  //   active: true,
  //   options: {
  //     type: 'specific_pages',
  //     view: 'my_account',
  //     specific_pages: [
  //       'my_account',
  //       'my_account.upcoming_registrations',
  //       'my_account.profile',
  //       'on_demand',
  //       'schedule.month',
  //       'memberships',
  //     ],
  //     free_trial_membership: null,
  //     // venue_ids: [
  //     //   51414,
  //     // ],
  //     disable_venue_selector: false,
  //   },
  // })

  const isWidget = !!widgetSettings?.active
  const widgetSettingsOptions = widgetSettings?.options
  const widgetSettingsOptionsType = widgetSettingsOptions?.type
  const widgetSettingsOptionsView = widgetSettingsOptions?.view
  const widgetSettingsOptionsSpecificPages = widgetSettingsOptions?.specific_pages

  return {
    isWidget,
    widgetSettingsOptions,
    widgetSettingsOptionsType,
    widgetSettingsOptionsView,
    widgetSettingsOptionsSpecificPages,
  }
}

export const useWidgetSettings = useSingleton(createInstance)
